const MAX_PRODUCTS = 3;
const FIELDS = Object.freeze([
  ["title", "Producto"],
  ["vendor", "Marca"],
  ["price", "Precio"],
  ["availability", "Disponibilidad"],
]);

export function canCompare(current, candidate) {
  if (!candidate?.category || current.length >= MAX_PRODUCTS) return false;
  return current.length === 0 || current.every((item) => item.category === candidate.category);
}

export function buildComparisonRows(products) {
  return FIELDS
    .map(([key, label]) => ({
      key,
      label,
      values: products.map((product) => String(product[key] ?? "Pendiente")),
    }))
    .filter((row) => row.values.length > 0 && new Set(row.values).size > 1);
}

function parseProduct(button) {
  try {
    const product = JSON.parse(button.dataset.compareProduct);
    return {
      id: String(product.id),
      title: String(product.title),
      url: String(product.url),
      category: String(product.category),
      vendor: String(product.vendor || "Pendiente"),
      price: String(product.price || "Pendiente"),
      availability: String(product.availability || "Pendiente"),
    };
  } catch {
    return null;
  }
}

export class CyclonComparison {
  constructor(root) {
    this.root = root;
    this.dialog = root.querySelector("[data-comparison-dialog]");
    this.body = root.querySelector("[data-comparison-body]");
    this.status = root.querySelector("[data-comparison-status]");
    this.products = [];
    document.querySelectorAll("[data-compare-product]").forEach((button) => {
      button.addEventListener("click", () => this.add(parseProduct(button)));
    });
    root.querySelector("[data-comparison-close]")?.addEventListener("click", () => {
      this.dialog?.close?.();
    });
    root.querySelector("[data-comparison-clear]")?.addEventListener("click", () => {
      this.products = [];
      this.render();
    });
  }

  add(product) {
    if (!product) return;
    if (this.products.some((item) => item.id === product.id)) {
      this.status.textContent = "Ese producto ya está en la comparación.";
      this.dialog?.showModal?.();
      return;
    }
    if (!canCompare(this.products, product)) {
      this.status.textContent = "Compará hasta tres productos de la misma categoría.";
      this.dialog?.showModal?.();
      return;
    }
    this.products.push(product);
    this.status.textContent = `${this.products.length} producto${this.products.length === 1 ? "" : "s"} en comparación.`;
    this.render();
    this.dialog?.showModal?.();
  }

  render() {
    if (!this.body) return;
    this.body.replaceChildren();
    for (const row of buildComparisonRows(this.products)) {
      const line = document.createElement("div");
      line.className = "cyclon-comparison__row";
      const label = document.createElement("strong");
      label.textContent = row.label;
      line.append(label);
      row.values.forEach((value) => {
        const cell = document.createElement("span");
        cell.textContent = value;
        line.append(cell);
      });
      this.body.append(line);
    }
  }
}

if (typeof document !== "undefined") {
  const root = document.querySelector("[data-cyclon-comparison]");
  if (root) new CyclonComparison(root);
}
